import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { SAVE_DRAFT_CONFIGURATION, SAVE_DRAFT_CONFIGURATION_SUCCESS, SAVE_DRAFT_CONFIGURATION_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* saveDraftConfiguration({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/benefit-type/airport-transfer/configuration`,
      method: 'POST',
      data: payload?.data,
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: SAVE_DRAFT_CONFIGURATION_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: SAVE_DRAFT_CONFIGURATION_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: SAVE_DRAFT_CONFIGURATION_ERROR, payload: error });
  }
}

export function* watchsaveDraftConfiguration() {
  yield takeEvery(SAVE_DRAFT_CONFIGURATION, saveDraftConfiguration);
}

function* saveDraftConfigurationSaga() {
  yield all([fork(watchsaveDraftConfiguration)]);
}

export default saveDraftConfigurationSaga;
